/**
 * Normalize the `MappingRow.transforms` JSONB shape to the discriminated union.
 *
 * Legacy bare arrays (Phase 5 of `52-followup-plugins` and earlier) become
 * `{ kind: 'inline', steps }`. New rows already have `kind` set. Garbage
 * (null/undefined/non-object/non-array) becomes `{ kind: 'inline', steps: [] }`
 * — lenient passthrough matching the existing chain-executor convention.
 */
export function normalizeTransforms(value) {
    if (Array.isArray(value)) {
        return { kind: 'inline', steps: value };
    }
    if (value && typeof value === 'object') {
        const v = value;
        if (v.kind === 'inline' && Array.isArray(v.steps)) {
            return value;
        }
        if (v.kind === 'named' && typeof v.namedChainId === 'string') {
            return value;
        }
    }
    return { kind: 'inline', steps: [] };
}
//# sourceMappingURL=normalize-transforms.js.map